import styled from 'styled-components/macro';

export const StyledTableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`;
